import { useState } from "react";

const OriginalSnapshotData = () => {
  const [originalData, setData] = useState([]);

  return {
    createOriginalSnapshot: appData => {
      if (
        originalData &&
        Object.keys(originalData).length == Object.keys(appData.values).length
      ) {
        return originalData;
      } else {
        setData(
          JSON.parse(JSON.stringify({ ...appData.values, ...originalData }))
        );

        return originalData;
      }
    }
  };
};

export default OriginalSnapshotData;
